import { ZoneSetupDetailsComponent } from './features/setup-screens/components/zone-setup-details/zone-setup-details.component';
import { AdministrationScreenComponent } from './features/administration/components/administration-screen/administration-screen.component';
import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { ProductDataContainerComponent } from './features/product-data/components/product-data-container/product-data-container.component';
import { SetupContainerComponent } from './features/setup-screens/components/setup-container/setup-container.component';
import { UnsavedChangesGuard } from './shared/guards/unsaved-changes.guard';
import { PermissionGuard } from './shared/guards/permission.guard';
import { HomeComponent } from './core/home/home.component';
import { LayoutComponent } from './core/layout/base-layout/layout.component';
import { MainLayoutComponent } from './core/layout/main-layout/main-layout.component';
import { ROUTE_PERMISSIONS } from './shared/constants/route-permissions';
import { AuthLoginComponent } from './features/authentication/components/auth-login/auth-login.component';
import { AuthGuard } from './features/authentication/services/auth-guard.service';
import { AccessDeniedComponent } from './shared/components/access-denied/access-denied.component';
import { CreateCamSpecLineComponent } from './features/cam-specification/components/create-cam-spec-line/create-cam-spec-line.component';
import { CreateCamSpecComponent } from './features/cam-specification/components/create-cam-spec/create-cam-spec.component';
import { ViewEditCamSpecLineComponent } from './features/cam-specification/components/view-edit-cam-spec-line/view-edit-cam-spec-line.component';
import { ViewEditCamSpecComponent } from './features/cam-specification/components/view-edit-cam-spec/view-edit-cam-spec.component';
import { CustomerScreenComponent } from './features/customer/components/customer-screen/customer-screen.component';
import { CustomerSetupComponent } from './features/customer/components/customer-setup/customer-setup.component';
import { MakeComponent } from './features/product-data/components/make-screen/make-screen.component';
import { AssignCamSpecComponent } from './features/search-cam-spec/components/assign-cam-spec/assign-cam-spec.component';
import { SearchCamSpecComponent } from './features/search-cam-spec/components/search-cam-spec/search-cam-spec.component';
import { ChangePasswordComponent } from './features/user-management/components/change-password/change-password.component';
import { UserGroupComponent } from './features/user-management/components/user-group/user-group.component';
import { UserInfoComponent } from './features/user-management/components/user-info/user-info.component';
import { UserSetupComponent } from './features/user-management/components/user-setup/user-setup.component';
import { UserComponent } from './features/user-management/components/user/user.component';
import { GroupComponent } from './features/user-management/components/user/group.component';
import { PreMoldScreenComponent } from './features/product-data/components/pre-mold-screen/pre-mold-screen.component';
import { CustomMoldScreenComponent } from './features/product-data/components/custom-mold-screen/custom-mold-screen.component';
import { SelectCustomerComponent } from './features/user-management/components/select-customer/select-customer.component';
import { WorkorderslistComponent } from './features/workorder/components/workorderslist/workorderslist.component';
import { WorkordersDetailsComponent } from './features/workorder/components/workorders-details/workorders-details.component';
import { WorkOrderLineDetailsComponent } from './features/workorder/components/work-order-line-details/work-order-line-details.component';
import { FinishedProductScreenComponent } from './features/product-data/components/finished-product-screen/finished-product-screen.component';
import { CasingSizeComponent } from './features/product-data/components/casing-size/casing-size.component';
import { SiteSetupSearchComponent } from './features/setup-screens/components/site-setup-search/site-setup-search.component';
import { SiteSetupDetailsComponent } from './features/setup-screens/components/site-setup-details/site-setup-details.component';
import { DealerSetupComponent } from './features/setup-screens/components/dealer-setup/dealer-setup.component';
import { CasingCreditComponent } from './features/product-data/components/casing-credit/casing-credit.component';
import { CasingCreditDetailsComponent } from './features/product-data/components/casing-credit-details/casing-credit-details.component';
import { CasingGradeComponent } from './features/product-data/components/casing-grade/casing-grade.component';
import { SearchCasingsComponent } from './features/search/components/search-casings/search-casings.component';
import { CasingSearchResultComponent } from './features/search/components/casing-search-result/casing-search-result.component';
import { TransferCasingExistingWorkorderComponent } from './features/search/components/transfer-casing-existing-workorder/transfer-casing-existing-workorder.component';
import { PacklistsComponent } from './features/packlists/components/packlists/packlists.component';
import { FreeRepairComponent } from './features/product-data/components/free-repair/free-repair.component';
import { PacklistDetailsComponent } from './features/packlists/components/packlist-details/packlist-details.component';
import { CasingCreditRepairComponent } from './features/product-data/components/casing-credit-repair/casing-credit-repair.component';
import { CasingCreditRepairDetailsComponent } from './features/product-data/components/casing-credit-repair-details/casing-credit-repair-details.component';
import { DisposalChargesComponent } from './features/product-data/components/disposal-charges/disposal-charges.component';
import { LogsComponent } from './features/logs/components/logs/logs.component';
import { DatasetDownloadComponent } from './features/dataset-download/components/dataset-download/dataset-download.component';
import { InventoryComponent } from './features/inventory/components/inventory/inventory.component';
import { CasingCreditRepairCreateComponent } from './features/product-data/components/casing-credit-repair-create/casing-credit-repair-create.component';
import { CasingCreditCreateComponent } from './features/product-data/components/casing-credit-create/casing-credit-create.component';
import { CasingCreditCopyComponent } from './features/product-data/components/casing-credit-copy/casing-credit-copy.component';
import { RejectReasonsComponent } from './features/product-data/components/reject-reasons/reject-reasons.component';
import { PlantSetupSearchComponent } from './features/setup-screens/components/plant-setup-search/plant-setup-search.component';
import { PlantSetupDetailsComponent } from './features/setup-screens/components/plant-setup-details/plant-setup-details.component';
import { CasingGradeTableDetailsComponent } from './features/product-data/components/casing-grade-table-details/casing-grade-table-details.component';
import { CasingGradeTableComponent } from './features/product-data/components/casing-grade-table/casing-grade-table.component';
import { RerunReworkReasonComponent } from './features/product-data/components/rerun-rework-reason/rerun-rework-reason.component';
import { RepairsComponent } from './features/product-data/components/repairs/repairs.component';
import { PreferredTreadsComponent } from './features/product-data/components/preferred-treads/preferred-treads.component';
import { PreferredTreadsSetupComponent } from './features/product-data/components/preferred-treads-setup/preferred-treads-setup.component';
import { FreeRepairSetupComponent } from './features/product-data/components/free-repair-setup/free-repair-setup.component';
import { ProductImportComponent } from './features/setup-screens/components/product-import/product-import.component';
import { CustomerAssignWrapperComponent } from './shared/components/customer-assign/customer-assign-wrapper.component';
import { POSComponent } from './features/setup-screens/components/point-of-sale/point-of-sale.component';
import { WheelAndTireServicesComponent } from './features/product-data/components/wheel-and-tire-services/wheel-and-tire-services.component';
import { CasingDefinitionComponent } from './features/product-data/components/casing-definition/casing-definition.component';
import { FactoryCodeComponent } from './features/product-data/components/factory-code/factory-code.component';
import { AdjustmentReasonsComponent } from './features/product-data/components/adjustment-reasons/adjustment-reasons.component';
import { ProductApplicationComponent } from './features/product-data/components/product-application/product-application.component';
import { ProductAxleComponent } from './features/product-data/components/product-axle/product-axle.component';
import { CasingFitmentComponent } from './features/product-data/components/casing-fitment/casing-fitment.component';
import { EmailSetupComponent } from './features/setup-screens/components/email-setup/email-setup.component';
import { CasingPurchaseComponent } from './features/product-data/components/casing-purchase/casing-purchase.component';
import { CasingPurchaseSetupComponent } from './features/product-data/components/casing-purchase-setup/casing-purchase-setup.component';
import { CasingPurchaseCreateComponent } from './features/product-data/components/casing-purchase-create/casing-purchase-create.component';
import { AccessibilityStatementComponent } from './features/help/components/accessibility-statement/accessibility-statement.component';
import { ROLES } from './features/authentication/authRoles.constants';

export const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: 'home/dealer/:dealerId/customerId/:customerId',
        component: MainLayoutComponent,
        canActivate: [AuthGuard],
        data: {
          type: 'dealer',
          role: 'SETUP_FLEET_SPECIFICATIONS_VIEW'
        },
        children: [
          {
            path: 'home/specifications',
            component: SearchCamSpecComponent
          }
        ]
      },
      {
        path: 'access-denied',
        component: AccessDeniedComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'home',
        component: MainLayoutComponent,
        canActivate: [AuthGuard],
        children: [
          { path: 'dashboard', component: HomeComponent },
          {
            path: 'productData',
            component: ProductDataContainerComponent,
            children: [
              {
                path: 'adjustmentReasons',
                component: AdjustmentReasonsComponent,
                canActivate: [PermissionGuard],
                canDeactivate: [UnsavedChangesGuard],
                data: { roles: ROUTE_PERMISSIONS['adjustmentReasons'] }
              },
              {
                path: 'application',
                component: ProductApplicationComponent,
                canActivate: [PermissionGuard],
                canDeactivate: [UnsavedChangesGuard],
                data: { roles: ROUTE_PERMISSIONS['application'] }
              },
              {
                path: 'axle',
                component: ProductAxleComponent,
                canActivate: [PermissionGuard],
                canDeactivate: [UnsavedChangesGuard],
                data: { roles: ROUTE_PERMISSIONS['axle'] }
              },
              { path: 'customer-assign/:Id', component: CustomerAssignWrapperComponent },
              {
                path: 'casingCredit',
                canActivate: [PermissionGuard],
                data: { roles: ROUTE_PERMISSIONS['casingCredit'] },
                children: [
                  { path: '', component: CasingCreditComponent },
                  { path: 'casingcreditdetails/:casingCreditId', component: CasingCreditDetailsComponent },
                  { path: 'createCasingCreditDetails', component: CasingCreditCreateComponent },
                  { path: 'copyCasingCredit/:casingCreditId', component: CasingCreditCopyComponent }
                ]
              },
              {
                path: 'casing-CreditRepair',
                canActivate: [PermissionGuard],
                data: { roles: ROUTE_PERMISSIONS['casing-CreditRepair'] },
                children: [
                  { path: '', component: CasingCreditRepairComponent },
                  {
                    path: 'casingcreditrepairdetails/:casingCreditRepairPk',
                    component: CasingCreditRepairDetailsComponent,
                    canDeactivate: [UnsavedChangesGuard]
                  },
                  { path: 'create', component: CasingCreditRepairCreateComponent, canDeactivate: [UnsavedChangesGuard] }
                ]
              },
              {
                path: 'casingDefinition',
                component: CasingDefinitionComponent,
                canActivate: [PermissionGuard],
                canDeactivate: [UnsavedChangesGuard],
                data: { roles: ROUTE_PERMISSIONS['casingDefinition'] }
              },
              {
                path: 'casingFitment',
                component: CasingFitmentComponent,
                canActivate: [PermissionGuard],
                canDeactivate: [UnsavedChangesGuard],
                data: { roles: ROUTE_PERMISSIONS['casingFitment'] }
              },
              {
                path: 'casingPurchase',
                canActivate: [PermissionGuard],
                data: { roles: ROUTE_PERMISSIONS['casingPurchase'] },
                children: [
                  { path: '', component: CasingPurchaseComponent },
                  { path: 'casingPurchaseSetup/:casingPurchasePk', component: CasingPurchaseSetupComponent },
                  { path: 'createCasingPurchase/:casingPurchasePk', component: CasingPurchaseCreateComponent },
                  { path: 'createCasingPurchase', component: CasingPurchaseCreateComponent }
                ]
              },
              {
                path: 'casingGrade',
                component: CasingGradeComponent,
                canActivate: [PermissionGuard],
                canDeactivate: [UnsavedChangesGuard],
                data: { roles: ROUTE_PERMISSIONS['casingGrade'] }
              },
              {
                path: 'casing-grade-table',
                canActivate: [PermissionGuard],
                data: { roles: ROUTE_PERMISSIONS['casing-grade-table'] },
                children: [
                  { path: '', component: CasingGradeTableComponent },
                  { path: 'create', component: CasingGradeTableDetailsComponent, canDeactivate: [UnsavedChangesGuard] },
                  {
                    path: ':casingGradeTablePk/copy',
                    component: CasingGradeTableDetailsComponent,
                    canDeactivate: [UnsavedChangesGuard]
                  },
                  { path: ':casingGradeTablePk', component: CasingGradeTableDetailsComponent, canDeactivate: [UnsavedChangesGuard] }
                ]
              },
              {
                path: 'casingSize',
                component: CasingSizeComponent,
                canActivate: [PermissionGuard],
                canDeactivate: [UnsavedChangesGuard],
                data: { roles: ROUTE_PERMISSIONS['casingSize'] }
              },
              {
                path: 'customMold',
                component: CustomMoldScreenComponent,
                canActivate: [PermissionGuard],
                canDeactivate: [UnsavedChangesGuard],
                data: { roles: ROUTE_PERMISSIONS['customMold'] }
              },
              {
                path: 'disposalCharges',
                component: DisposalChargesComponent,
                canActivate: [PermissionGuard],
                canDeactivate: [UnsavedChangesGuard],
                data: { roles: ROUTE_PERMISSIONS['disposalCharges'] }
              },
              {
                path: 'factoryCode',
                component: FactoryCodeComponent,
                canActivate: [PermissionGuard],
                canDeactivate: [UnsavedChangesGuard],
                data: { roles: ROUTE_PERMISSIONS['factoryCode'] }
              },
              {
                path: 'finishedProduct',
                component: FinishedProductScreenComponent,
                canActivate: [PermissionGuard],
                canDeactivate: [UnsavedChangesGuard],
                data: { roles: ROUTE_PERMISSIONS['finishedProduct'] }
              },
              {
                path: 'freeRepair',
                canActivate: [PermissionGuard],
                data: { roles: ROUTE_PERMISSIONS['freeRepair'] },
                children: [
                  { path: '', component: FreeRepairComponent },
                  { path: 'freeRepairSetup/:freeRepairId', component: FreeRepairSetupComponent, canDeactivate: [UnsavedChangesGuard] }
                ]
              },
              {
                path: 'make',
                component: MakeComponent,
                canActivate: [PermissionGuard],
                canDeactivate: [UnsavedChangesGuard],
                data: { roles: ROUTE_PERMISSIONS['make'] }
              },
              {
                path: 'preferred-treads',
                canActivate: [PermissionGuard],
                data: { roles: ROUTE_PERMISSIONS['preferred-treads'] },
                children: [
                  { path: '', component: PreferredTreadsComponent, canDeactivate: [UnsavedChangesGuard] },
                  {
                    path: 'preferred-treads-setup/:preferredTreadPk',
                    component: PreferredTreadsSetupComponent,
                    canDeactivate: [UnsavedChangesGuard]
                  }
                ]
              },
              {
                path: 'preMold',
                component: PreMoldScreenComponent,
                canActivate: [PermissionGuard],
                canDeactivate: [UnsavedChangesGuard],
                data: { roles: ROUTE_PERMISSIONS['preMold'] }
              },
              {
                path: 'rejectReasons',
                component: RejectReasonsComponent,
                canActivate: [PermissionGuard],
                canDeactivate: [UnsavedChangesGuard],
                data: { roles: ROUTE_PERMISSIONS['rejectReasons'] }
              },
              {
                path: 'repairs',
                component: RepairsComponent,
                canActivate: [PermissionGuard],
                canDeactivate: [UnsavedChangesGuard],
                data: { roles: ROUTE_PERMISSIONS['repairs'] }
              },
              {
                path: 'rerunReworkReasons',
                component: RerunReworkReasonComponent,
                canActivate: [PermissionGuard],
                data: { roles: ROUTE_PERMISSIONS['rerunReworkReasons'] }
              },
              {
                path: 'wheelAndTireServices',
                component: WheelAndTireServicesComponent,
                canActivate: [PermissionGuard],
                canDeactivate: [UnsavedChangesGuard],
                data: { roles: ROUTE_PERMISSIONS['wheelAndTireServices'] }
              }
            ]
          },
          {
            path: 'setup',
            component: SetupContainerComponent,
            children: [
              {
                path: 'plantSetup',
                canActivate: [PermissionGuard],
                data: { roles: ROUTE_PERMISSIONS['plantSetup'] },
                children: [
                  { path: '', component: PlantSetupSearchComponent },
                  {
                    path: 'create',
                    component: PlantSetupDetailsComponent,
                    canDeactivate: [UnsavedChangesGuard]
                  },
                  {
                    path: ':plantId',
                    component: PlantSetupDetailsComponent,
                    canDeactivate: [UnsavedChangesGuard]
                  }
                ]
              },
              {
                path: 'productImport',
                component: ProductImportComponent,
                canActivate: [PermissionGuard],
                data: { roles: ROUTE_PERMISSIONS['productImport'] }
              },
              {
                path: 'pointOfSale',
                component: POSComponent,
                canActivate: [PermissionGuard],
                data: { roles: ROUTE_PERMISSIONS['pointOfSale'] }
              },
              {
                path: 'emailSetup',
                component: EmailSetupComponent,
                canActivate: [PermissionGuard],
                canDeactivate: [UnsavedChangesGuard],
                data: { roles: ROUTE_PERMISSIONS['emailSetup'] }
              },
              {
                path: 'siteSetup',
                canActivate: [PermissionGuard],
                data: { roles: ROUTE_PERMISSIONS['siteSetup'] },
                children: [
                  { path: '', component: SiteSetupSearchComponent },
                  {
                    path: ':siteId',
                    component: SiteSetupDetailsComponent,
                    canDeactivate: [UnsavedChangesGuard]
                  }
                ]
              },
              {
                path: 'dealerSetup',
                canActivate: [PermissionGuard],
                data: { roles: ROUTE_PERMISSIONS['dealerSetup'] },
                children: [{ path: '', component: DealerSetupComponent, canDeactivate: [UnsavedChangesGuard] }]
              },
              {
                path: 'zoneSetup',
                component: ZoneSetupDetailsComponent,
                canActivate: [PermissionGuard],
                canDeactivate: [UnsavedChangesGuard],
                data: { roles: ROUTE_PERMISSIONS['zoneSetup'] }
              },
              {
                path: 'usersetup',
                component: UserSetupComponent,
                canActivate: [PermissionGuard],
                data: { roles: ROUTE_PERMISSIONS['usersetup'] },
                children: [
                  { path: '', component: UserComponent },
                  { path: 'user-group', component: GroupComponent },
                  { path: 'user-group/:group-name/:groupId', component: UserGroupComponent, canDeactivate: [UnsavedChangesGuard] },
                  { path: 'user', component: UserInfoComponent, canDeactivate: [UnsavedChangesGuard] },
                  { path: 'user/:userId', component: UserInfoComponent, canDeactivate: [UnsavedChangesGuard] },
                  { path: 'user/:userId/select-customer', component: SelectCustomerComponent, canDeactivate: [UnsavedChangesGuard] },
                  { path: 'user-group/create', component: UserGroupComponent, canDeactivate: [UnsavedChangesGuard] }
                ]
              }
            ]
          },
          {
            path: 'customer-assign/:Id',
            redirectTo: 'productData/customer-assign/:Id',
            pathMatch: 'full'
          },
          {
            path: 'plantSetup',
            redirectTo: 'setup/plantSetup',
            pathMatch: 'full'
          },
          {
            path: 'productImport',
            redirectTo: 'setup/productImport',
            pathMatch: 'full'
          },
          {
            path: 'siteSetup',
            redirectTo: 'setup/siteSetup',
            pathMatch: 'full'
          },
          {
            path: 'dealerSetup',
            redirectTo: 'setup/dealerSetup',
            pathMatch: 'full'
          },
          {
            path: 'zoneSetup',
            redirectTo: 'setup/zoneSetup',
            pathMatch: 'full'
          },
          {
            path: 'usersetup',
            redirectTo: 'setup/usersetup',
            pathMatch: 'full'
          },
          {
            path: 'usersetup/user-group',
            redirectTo: 'setup/usersetup/user-group',
            pathMatch: 'full'
          },
          {
            path: 'packlists',
            canActivate: [PermissionGuard],
            data: { roles: ROUTE_PERMISSIONS['packlist'] },
            children: [
              { path: '', component: PacklistsComponent },
              {
                path: ':packListId',
                component: PacklistDetailsComponent
              }
            ]
          },
          {
            path: 'administration',
            canActivate: [PermissionGuard],
            data: { roles: ROUTE_PERMISSIONS['administration'] },
            component: AdministrationScreenComponent
          },
          {
            path: 'logs',
            component: LogsComponent
          },
          {
            path: 'datasetDownload',
            component: DatasetDownloadComponent
          },
          {
            path: 'help/accessibility-statement',
            component: AccessibilityStatementComponent
          },
          {
            path: 'inventory',
            canActivate: [PermissionGuard],
            data: { roles: ROUTE_PERMISSIONS['inventory'] },
            component: InventoryComponent
          },
          {
            path: 'pointOfSale',
            redirectTo: 'setup/pointOfSale',
            pathMatch: 'full'
          },
          {
            path: 'emailSetup',
            redirectTo: 'setup/emailSetup',
            pathMatch: 'full'
          },
          {
            path: 'specifications',
            canActivate: [PermissionGuard],
            data: { roles: ROUTE_PERMISSIONS['specifications'] },
            children: [
              { path: '', component: SearchCamSpecComponent },
              { path: 'assigncams/:specDesc/:specId', component: AssignCamSpecComponent },
              {
                path: 'create',
                component: CreateCamSpecComponent,
                children: [{ path: 'line/:specificationLineIndex', component: CreateCamSpecLineComponent }]
              },
              {
                path: ':specificationId',
                component: ViewEditCamSpecComponent,
                children: [{ path: 'lines/:specificationLineId', component: ViewEditCamSpecLineComponent }]
              }
            ]
          },
          {
            path: 'customers',
            canActivate: [PermissionGuard],
            data: { roles: ROUTE_PERMISSIONS['customers'] },
            children: [
              { path: '', component: CustomerScreenComponent },
              { path: ':customerId', component: CustomerSetupComponent, canDeactivate: [UnsavedChangesGuard] }
            ]
          },
          {
            path: 'work-orders',
            canActivate: [PermissionGuard],
            data: { roles: ROUTE_PERMISSIONS['work-orders'] },
            children: [
              { path: '', component: WorkorderslistComponent },
              {
                path: 'create',
                loadChildren: () =>
                  import('./features/workorder/components/createworkorder/createworkorder.module').then((m) => m.CreateWorkOrderModule),
                canActivate: [AuthGuard]
              },
              { path: 'work-orders-details/:workOrderId', component: WorkordersDetailsComponent, canDeactivate: [UnsavedChangesGuard] },
              {
                path: 'work-order-line-details/:workOrderId/:workOrderLineId',
                component: WorkOrderLineDetailsComponent,
                canDeactivate: [UnsavedChangesGuard]
              }
            ]
          },
          {
            path: 'work-orders',
            children: [
              { path: '', component: WorkorderslistComponent },
              {
                path: 'transfer-to-new-wo',
                loadChildren: () =>
                  import('./features/workorder/components/rscasingtransfer/createworkorder.module').then((m) => m.CreateWorkOrderModule),
                canActivate: [AuthGuard],
                data: { roles: [ROLES.create_work_orders] }
              },
              { path: 'casingtransfer', redirectTo: 'transfer-to-new-wo', pathMatch: 'full' },
              { path: 'work-orders-details/:workOrderId', component: WorkordersDetailsComponent, canDeactivate: [UnsavedChangesGuard] },
              {
                path: 'work-order-line-details/:workOrderId/:workOrderLineId',
                component: WorkOrderLineDetailsComponent,
                canDeactivate: [UnsavedChangesGuard]
              }
            ]
          },
          {
            path: 'search-casings',
            canActivate: [PermissionGuard],
            data: { roles: ROUTE_PERMISSIONS['search-casings'] },
            children: [
              { path: '', component: SearchCasingsComponent },
              { path: 'results', component: CasingSearchResultComponent },
              { path: 'transfer-casings', component: TransferCasingExistingWorkorderComponent },
              { path: ':casingId', component: SearchCasingsComponent, canDeactivate: [UnsavedChangesGuard] }
            ]
          }
        ]
      },
      {
        path: 'home/changepassword',
        component: MainLayoutComponent,
        canActivate: [AuthGuard],
        children: [{ path: '', component: ChangePasswordComponent }]
      }
    ]
  },
  { path: 'authlogin', component: AuthLoginComponent },
  { path: '**', redirectTo: 'fail', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, scrollPositionRestoration: 'top' })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
